import React from 'react';
import { ImagenCliente } from '../../configuracion/apiUrls';
import { useContextUsuario } from '../../contexto/usuario/UsuarioContext';
import ModalClientes from '../../paginas/clientes/ModalClientes';

const PerfilCliente = ({ datos }) => {
    const { usuario } = useContextUsuario();

    const imagen = usuario?.datoPersonales.imagen ? ImagenCliente + usuario?.datoPersonales.imagen : ImagenCliente + "cliente.jpeg";

    return (
        <div className="card card-primary card-outline" style={{ width: '300px', height: 'auto' }}> {/* Definir tamaño del card */}
            <div className="card-body box-profile">
                <div className="text-center">
                    <img 
                        className="profile-user-img img-fluid img-circle" 
                        src={imagen} 
                        alt="Imagen de perfil de usuario" 
                        crossOrigin="anonymous" 
                        style={{ width: '120px', height: '120px' }} /> {/* Definir tamaño de la imagen */}
                </div>
                <h3 className="profile-username text-center">{usuario?.datoPersonales.nombreCompleto}</h3>
                <hr />
                <div className="card-body">
                    <strong><i className="fas fa-envelope mr-1" /> Correo</strong>
                    <p className="text-muted">
                        {usuario?.correo}
                    </p>
                    <strong><i className="fas fa-phone mr-1" /> Telefonos</strong>
                    {
                        usuario?.datoPersonales.ClienteTelefonos
                            .map((f, i) => (
                                <p key={i} className="text-muted">
                                    {f.telefono}
                                </p>
                            ))
                    }
                    <strong><i className="fas fa-map-marker-alt mr-1" /> Direcciones</strong>
                    {
                        usuario?.datoPersonales.ClienteDireccions.map((f, i) => (
                            <p key={i} className="text-muted">
                                {f.direccion}
                            </p>
                        ))
                    }
                    <hr />
                </div>
                <ModalClientes datos={usuario}></ModalClientes>
            </div>
        </div>
    );
}

export default PerfilCliente;
